import { render } from "./JsonField.vue?vue&type=template&id=f96202a2&scoped=true"
import script from "./JsonField.vue?vue&type=script&lang=js"
export * from "./JsonField.vue?vue&type=script&lang=js"

import "./JsonField.vue?vue&type=style&index=0&id=f96202a2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quick_wucode\\quick_wucode\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96202a2"]])

export default __exports__